export const tractionAIMainStyles =  {
  title: {
    color: '#0b4f71',
    fontFamily: 'lato-Bold'
  }
}
export const AI_MAIN_OPTIONS = [
  {
    id: 'scout',
    name: 'Scout for technologies or companies to solve a problem'
  },
  {
    id: 'insight',
    name: 'Provide Research Insights (SWOT + Trend Reports)'
  },
  {
    id: 'recommend',
    name: 'Recommend Companies, Projects, or Ideas'
  },
  {
    id: 'populate',
    name: 'Populate Company profiles with missing data'
  },
];
